import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { DocumentsApiService } from 'features/document-report/api/documents-api.service';
import { NewClientsResponse } from 'features/new-clients/api/new-clients-api.service';

import { DocumentQueryKeys } from './query-keys';
const { getDocumentPendingList } = DocumentsApiService();

export const usePendingDocuments = (
  CompanyId: string, // Include ParentId as a parameter
  options?: UseQueryOptions<NewClientsResponse, Error>,
) => {
  const { message } = App.useApp();

  return useQuery<any, Error>(
    [DocumentQueryKeys.all, CompanyId], // Include parentId in the query key
    () => getDocumentPendingList(CompanyId), // Pass both flag and parentId to dropDownByFlag
    {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);
        message.error(uiMessage);
      },
      ...options,
    },
  );
};
